import { IUseScanAndPay } from './types';

/**
 *
 * TH ONLY -- stub this for BK/PLK
 *
 */
export const useScanAndPay = (): IUseScanAndPay => {
  return {
    loadingSelectedPaymentMethod: false,
    loadingStatus: false,
    nonSelectedPaymentMethods: [],
    scanAndPayBarcode: '',
    scanAndPayEnabledForUser: false,
    selectedPaymentMethodId: '',
    selectedPaymentMethod: undefined,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateScanAndPayStatus: (newStatus: boolean) =>
      Promise.resolve({ data: { setLoyaltyScanAndPay: { scanAndPay: false } } }),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateSelectedScanAndPayPaymentMethod: (newPaymentMethodId: string) => undefined,
    updatingSelectedPaymentMethod: false,
    updatingStatus: false,
    userHasValidScanAndPayPaymentMethodOption: false,
  };
};
